// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"17":"239dc750","55":"ab3ac744","188":"89eefc82","236":"085d0d51","239":"ce722ccf","241":"fc75a519","270":"6355f347","453":"f31200d3","506":"77702bbf","621":"1c6ef3e1","622":"a9ef9a3e","668":"b52ddacb","896":"7becbf5c"}[chunkId] + ".chunk.js";
};